(function() {
    'use strict';
    angular.module('emarket.commons').factory('StateQueue', ['$log', '$state', function($log, $state) {
        var states = [];
        var defaulState = {
            name: 'main.home'
        };
        var stateQueue = {
            pop: function() {
                if (states.length === 0) {
                    return defaulState;
                } else {
                    return states.pop();
                }
            },
            push: function(state) {
                var nextState = stateQueue.getNext();
                if (state && !state.abstract && !nextState.sticky) {
                    states.push(state);
                }
            },
            getNext: function() {
                var state;
                if (states.length > 0) {
                    state = states[states.length - 1];
                } else {
                    state = defaulState;
                }
                return state;
            },
            go: function(extraParams) {
                var state = stateQueue.pop();
                if (!state.params) {
                    state.params = {};
                }
                if (extraParams) {
                    Object.keys(extraParams).forEach(function(key) {
                        state.params[key] = extraParams[key];
                    });
                }
                $state.go(state.name, state.params);
            }
        };
        return stateQueue;
    }]);
}());
